<template>
  <!-- The `#hearty` gradient referenced below is defined once in App.vue, so every heart
       shares a single valid paint server (see App.vue for why duplicating it breaks mobile). -->
  <div class="heart-container">
    <font-awesome-icon :icon="['fas', 'heart']"/>
  </div>
</template>

<script setup>
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
</script>

<style>

.heart-container svg * {
  fill: url(#hearty);
}
</style>